import { Injectable, inject } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, catchError, tap } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'src/app/message';
import { AuthService } from '../services';
import { Router } from '@angular/router';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  private translate: TranslateService = inject(TranslateService);
  private _message: MessageService = inject(MessageService);
  private _auth: AuthService = inject(AuthService);
  private _router = inject(Router);

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return next
      .handle(request)
      .pipe(catchError(error => this.errorHandler(error)));
  }

  private errorHandler(error: HttpEvent<any>): Observable<HttpEvent<any>> {
    if (error instanceof HttpErrorResponse) {
      const { key, status } = error.error;
      if (key) {
        this.handleKeyError(key);
      } else if (error?.error?.errors?.PhoneNumber) {
        this._message.emitError(
          this.translate.instant('httpErrors.MODEL_VALIDATION_PHONE_FORMAT')
        );
      } else {
        this.handleStatusError(status);
      }
    }
    throw error;
  }

  private handleKeyError(key: string) {
    console.log('handleKeyError', key);
    switch (key) {
      case 'UNAUTHORIZED':
        this._auth.logout();
        break;
      case 'EXPIRED_TOKEN':
        // eslint-disable-next-line no-case-declarations
        // const url = this._router.routerState.snapshot.url;
        // this._auth.refreshIdToken(url ? url : undefined);
        // eslint-disable-next-line no-case-declarations
        const lang = localStorage.getItem('ml_lang') || 'es'; // save lang before clear()
        localStorage.clear();
        localStorage.setItem('ml_lang', lang);
        try {
          window.location.reload();
        } catch (e: any) {
          console.log('handleKeyError', key);
        }

        // this._auth.logout().subscribe();
        break;
      case 'VALIDATION_USER_NOT_FOUND':
        this._message.emitError(
          this.translate.instant(`httpErrors.VALIDATION_USER_NOT_FOUND`)
        );
        break;
      default:
        this._message.emitError(this.translate.instant(`httpErrors.${key}`));
        break;
    }
  }

  private handleStatusError(status: number) {
    const errorMessages: { [status: number]: string } = {
      400: 'Bad request',
      401: 'Unauthorized',
      404: 'Not found',
      500: 'Server error',
    };

    const errorMessage = errorMessages[status] || 'Something went wrong';
    if (status === 401) {
      this._auth.logout();
    } else {
      this._message.emitError(errorMessage);
    }
  }
}
